const $ = jQuery;

class GateForm {
	constructor (formId) {
		this.$form = $(`#${formId}`);
		this.formValid = false;

		this.$form.on('formvalid.zf.abide', () => this.onFormValid());
		this.$form.on('forminvalid.zf.abide', () => this.onFormInvalid());
		this.$form.on('submit', e => this.onSubmit(e));
	}

	getSubmitButton () {
		return this.$form.find('button[type=submit]');
	}

	disableSubmitButton () {
		this.getSubmitButton().attr('disabled', true);
	}

	enableSubmitButton () {
		this.getSubmitButton().removeAttr('disabled');
	}

	onSubmit (e) {
		this.disableSubmitButton();

		e.preventDefault();

		if (!this.formvalid) {
			this.enableSubmitButton();
			return;
		}

		const data = this.$form.serializeObject();

		window.marketoSubmit(data).then(() => {
			const event = new GateFormSubmittedEvent(data);
			event.trigger();
		});
	}

	onFormValid () {
		this.formvalid = true;
	}

	onFormInvalid () {
		this.formvalid = false;
	}
}

$(document).ready(() => {
	$('[data-component=gate-form]').each((i, e) => {
		new GateForm($(e).attr('id'));
	});
});
